export default __webpack_public_path__ + "static/media/tabAddNew.82a97ff7.svg";